import { NgModule, Inject, Optional } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsRunner } from './effects_runner';
import { EffectSources } from './effect_sources';
import { ROOT_EFFECTS } from './tokens';
export class EffectsRootModule {
/**
 * @param {?} sources
 * @param {?} runner
 * @param {?} rootEffects
 * @param {?} storeModule
 */
constructor(
private sources: EffectSources,
    runner: EffectsRunner,
     rootEffects: any[],
     storeModule: StoreModule
  ) {
    runner.start();

    rootEffects.forEach(effectSourceInstance =>
      sources.addEffects(effectSourceInstance)
    );
  }
/**
 * @param {?} effectSourceInstance
 * @return {?}
 */
addEffects(effectSourceInstance: any) {
    this.sources.addEffects(effectSourceInstance);
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: EffectSources, },
{type: EffectsRunner, },
{type: Array, decorators: [{ type: Inject, args: [ROOT_EFFECTS, ] }, ]},
{type: StoreModule, decorators: [{ type: Optional }, ]},
];
}

function EffectsRootModule_tsickle_Closure_declarations() {
/** @type {?} */
EffectsRootModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EffectsRootModule.ctorParameters;
/** @type {?} */
EffectsRootModule.prototype.sources;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/effects_root_module.ts